// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Consent_Medium;
(function (Consent_Medium) {
    Consent_Medium["MEDIUM_UNSPECIFIED"] = "MEDIUM_UNSPECIFIED";
    Consent_Medium["MEDIUM_WEB_FORM"] = "MEDIUM_WEB_FORM";
    Consent_Medium["MEDIUM_PHYSICAL_FORM"] = "MEDIUM_PHYSICAL_FORM";
    Consent_Medium["MEDIUM_SMS"] = "MEDIUM_SMS";
    Consent_Medium["MEDIUM_IN_PERSON"] = "MEDIUM_IN_PERSON";
    Consent_Medium["MEDIUM_VOICE_PHONE"] = "MEDIUM_VOICE_PHONE";
    Consent_Medium["MEDIUM_EMAIL"] = "MEDIUM_EMAIL";
    Consent_Medium["MEDIUM_WEAVE_SUPPORT"] = "MEDIUM_WEAVE_SUPPORT";
    Consent_Medium["MEDIUM_API"] = "MEDIUM_API";
    Consent_Medium["MEDIUM_WEAVE_SETTINGS"] = "MEDIUM_WEAVE_SETTINGS";
})(Consent_Medium || (Consent_Medium = {}));
export var Consent_Medium_index;
(function (Consent_Medium_index) {
    Consent_Medium_index[Consent_Medium_index["MEDIUM_UNSPECIFIED"] = 0] = "MEDIUM_UNSPECIFIED";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_WEB_FORM"] = 1] = "MEDIUM_WEB_FORM";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_PHYSICAL_FORM"] = 2] = "MEDIUM_PHYSICAL_FORM";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_SMS"] = 3] = "MEDIUM_SMS";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_IN_PERSON"] = 4] = "MEDIUM_IN_PERSON";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_VOICE_PHONE"] = 5] = "MEDIUM_VOICE_PHONE";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_EMAIL"] = 6] = "MEDIUM_EMAIL";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_WEAVE_SUPPORT"] = 7] = "MEDIUM_WEAVE_SUPPORT";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_API"] = 8] = "MEDIUM_API";
    Consent_Medium_index[Consent_Medium_index["MEDIUM_WEAVE_SETTINGS"] = 9] = "MEDIUM_WEAVE_SETTINGS";
})(Consent_Medium_index || (Consent_Medium_index = {}));
export var Consent_Action;
(function (Consent_Action) {
    Consent_Action["ACTION_UNSPECIFIED"] = "ACTION_UNSPECIFIED";
    Consent_Action["ACTION_FORM_SUBMIT"] = "ACTION_FORM_SUBMIT";
    Consent_Action["ACTION_SIGNATURE"] = "ACTION_SIGNATURE";
    Consent_Action["ACTION_SMS_KEYWORD"] = "ACTION_SMS_KEYWORD";
    Consent_Action["ACTION_SMS_INBOUND_MESSAGE"] = "ACTION_SMS_INBOUND_MESSAGE";
    Consent_Action["ACTION_VERBAL"] = "ACTION_VERBAL";
    Consent_Action["ACTION_EMAIL_BODY_UNSUBSCRIBE_CLICK"] = "ACTION_EMAIL_BODY_UNSUBSCRIBE_CLICK";
    Consent_Action["ACTION_SPAM_REPORT"] = "ACTION_SPAM_REPORT";
    Consent_Action["ACTION_WAM_BUTTON"] = "ACTION_WAM_BUTTON";
    Consent_Action["ACTION_POST_UNSUBSCRIBE"] = "ACTION_POST_UNSUBSCRIBE";
    Consent_Action["ACTION_UPDATE_WEAVE_SETTINGS"] = "ACTION_UPDATE_WEAVE_SETTINGS";
    Consent_Action["ACTION_PHONE_DTMF"] = "ACTION_PHONE_DTMF";
    Consent_Action["ACTION_TESTING"] = "ACTION_TESTING";
})(Consent_Action || (Consent_Action = {}));
export var Consent_Action_index;
(function (Consent_Action_index) {
    Consent_Action_index[Consent_Action_index["ACTION_UNSPECIFIED"] = 0] = "ACTION_UNSPECIFIED";
    Consent_Action_index[Consent_Action_index["ACTION_FORM_SUBMIT"] = 1] = "ACTION_FORM_SUBMIT";
    Consent_Action_index[Consent_Action_index["ACTION_SIGNATURE"] = 2] = "ACTION_SIGNATURE";
    Consent_Action_index[Consent_Action_index["ACTION_SMS_KEYWORD"] = 3] = "ACTION_SMS_KEYWORD";
    Consent_Action_index[Consent_Action_index["ACTION_SMS_INBOUND_MESSAGE"] = 4] = "ACTION_SMS_INBOUND_MESSAGE";
    Consent_Action_index[Consent_Action_index["ACTION_VERBAL"] = 5] = "ACTION_VERBAL";
    Consent_Action_index[Consent_Action_index["ACTION_EMAIL_BODY_UNSUBSCRIBE_CLICK"] = 6] = "ACTION_EMAIL_BODY_UNSUBSCRIBE_CLICK";
    Consent_Action_index[Consent_Action_index["ACTION_SPAM_REPORT"] = 7] = "ACTION_SPAM_REPORT";
    Consent_Action_index[Consent_Action_index["ACTION_WAM_BUTTON"] = 8] = "ACTION_WAM_BUTTON";
    Consent_Action_index[Consent_Action_index["ACTION_POST_UNSUBSCRIBE"] = 9] = "ACTION_POST_UNSUBSCRIBE";
    Consent_Action_index[Consent_Action_index["ACTION_UPDATE_WEAVE_SETTINGS"] = 10] = "ACTION_UPDATE_WEAVE_SETTINGS";
    Consent_Action_index[Consent_Action_index["ACTION_PHONE_DTMF"] = 11] = "ACTION_PHONE_DTMF";
    Consent_Action_index[Consent_Action_index["ACTION_TESTING"] = 12] = "ACTION_TESTING";
})(Consent_Action_index || (Consent_Action_index = {}));
export const CommPreferenceConsentService = {
    RegisterConsent(fn, req) {
        return fn(`/comm-preference/consent/v1/consent`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Unsubscribe(fn, _req) {
        return fn(`/comm-preference/consent/v1/unsubscribe`, { method: "POST" });
    },
};
